import { ReactNode, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import useUser from 'hooks/useUser';
import { getTeamsForAdmin } from 'utils/adminUtils';

interface AdminRouteProps {
  children: ReactNode;
  requiredRole?: string;
}

function AdminRoute({ children, requiredRole }: AdminRouteProps): ReactNode {
  const { roles, displayName } = useUser();
  const teamIds = getTeamsForAdmin(roles);
  const { teamId } = useParams();
  const navigate = useNavigate();

  const isMissingRequiredRoleForTeam = requiredRole && !roles.includes(`${teamId}${requiredRole}`);

  useEffect(() => {
    if (displayName === 'Unknown User') {
      return;
    }
    if (teamIds.length === 0 || isMissingRequiredRoleForTeam) {
      navigate('/notfound', { replace: true });
    }
  }, [displayName, teamIds, isMissingRequiredRoleForTeam, navigate]);

  if (teamIds.length === 0 || isMissingRequiredRoleForTeam) {
    return null;
  }

  return children;
}

export default AdminRoute;
